/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {
  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    const button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.toggle('open-cc');
        this.container.classList.toggle('active');
        this.container.removeAttribute('inert');
      });
    }
  }
}

/**
 *  @class
 *  @function SidebarToggle
 */
class SidebarToggle {
  constructor() {
    this.container = document.getElementById('Sidebar-Container');
    const button = document.getElementById('Sidebar-Toggle');

    // Add functionality to buttons
    if (button) {
      const span = button.querySelector('span');

      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.container.classList.toggle('facets--sidebar-open');

        span.textContent = this.container.classList.contains('facets--sidebar-open') ? theme.strings.hideFilters : theme.strings.showFilters;
      });
    }
  }
}

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    // Prevenir inicialización múltiple
    if (this.initialized) {
      return;
    }
    this.initialized = true;
    this.isProcessing = false;
    
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onSortChange = this.onSortChange.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500); // Aumentado a 500ms para mayor estabilidad

    // Remover event listeners existentes antes de agregar nuevos
    this.removeExistingListeners();
    
    this.querySelectorAll('.thb-filter-content--button').forEach((more_button) => {
      more_button.addEventListener('click', this.onMore);
    });

    // Agregar listener específico para el ordenamiento
    const sortSelect = document.getElementById('SortByBar');
    if (sortSelect) {
      sortSelect.addEventListener('change', this.onSortChange);
    }
    
    this.initializeFormListeners();
  }
  
  removeExistingListeners() {
    const form = this.querySelector('form');
    if (form) {
      // Clonar el formulario para remover todos los event listeners
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);
    }
  }
  
  initializeFormListeners() {
    const form = this.querySelector('form');
    if (form && !form.hasAttribute('data-listeners-initialized')) {
      form.setAttribute('data-listeners-initialized', 'true');
      
      // Usar un solo event listener con delegación de eventos
      form.addEventListener('change', (event) => {
        if (this.isProcessing) return;
        
        const target = event.target;
        if (target.type === 'checkbox' || target.type === 'radio' || target.name === 'sort_by') {
          this.debouncedOnSubmit(event);
        }
      });
      
      form.addEventListener('input', (event) => {
        if (this.isProcessing) return;
        
        const target = event.target;
        if (target.type === 'text' || target.type === 'number' || 
            target.classList.contains('field__input_min') || 
            target.classList.contains('field__input_max')) {
          this.debouncedOnSubmit(event);
        }
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    try {
      // Cancelar petición anterior si existe
      if (FacetFiltersForm.currentFetch) {
        FacetFiltersForm.currentFetch.abort();
      }
      
      // Prevenir renderizado si ya se está procesando la misma búsqueda
      if (FacetFiltersForm.searchParamsPrev === searchParams) {
        return;
      }
      
      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();
      
      if (!sections || sections.length === 0) {
        console.warn('No sections found for rendering');
        return;
      }
      
      const container = document.querySelectorAll('.thb-filter-count, .mobile-filter-count');
      const productGridContainer = document.getElementById('ProductGridContainer');
      
      // Agregar clases de loading de forma segura
      if (productGridContainer) {
        const collection = productGridContainer.querySelector('.collection');
        if (collection) {
          collection.classList.add('loading');
        }
      }

      container.forEach(item => {
        if (item) {
          item.classList.add('loading');
        }
      });

      // Procesar secciones de forma segura
      sections.forEach((section) => {
        if (!section || !section.section) {
          console.warn('Invalid section data:', section);
          return;
        }
        
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = element => element && element.url === url;

        if (FacetFiltersForm.filterData.some(filterDataUrl)) {
          FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
        } else {
          FacetFiltersForm.renderSectionFromFetch(url, event);
        }
      });
      
      if (updateURLHash) {
        FacetFiltersForm.updateURLHash(searchParams);
      }
      
    } catch (error) {
      console.error('Error in renderPage:', error);
      // Restablecer el estado en caso de error
      FacetFiltersForm.currentFetch = null;
    }
  }

  static renderSectionFromFetch(url, event) {
    // Crear un AbortController para esta petición
    const controller = new AbortController();
    FacetFiltersForm.currentFetch = controller;
    
    fetch(url, { signal: controller.signal })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        // Verificar si la petición fue cancelada
        if (controller.signal.aborted) {
          return;
        }
        
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        // SOLUCIÓN DE EMERGENCIA: No reinstanciar clases que pueden causar duplicados
        // new FacetsToggle();
        // new SidebarToggle();
        
        // Limpiar la referencia del fetch actual
        FacetFiltersForm.currentFetch = null;
      })
      .catch((error) => {
        // No mostrar error si fue cancelado intencionalmente
        if (error.name !== 'AbortError') {
          console.error('Error fetching filter data:', error);
        }
        FacetFiltersForm.currentFetch = null;
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
    new SidebarToggle();
  }

  static renderProductGridContainer(html) {
    try {
      const container = document.getElementById('ProductGridContainer');
      if (!container) {
        console.warn('ProductGridContainer not found');
        return;
      }

      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(html, 'text/html');
      const newContainer = parsedDoc.getElementById('ProductGridContainer');
      
      if (!newContainer) {
        console.warn('ProductGridContainer not found in parsed HTML');
        return;
      }

      container.innerHTML = newContainer.innerHTML;

      // Calcular scroll de forma segura
      const containerRect = container.getBoundingClientRect();
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      const top = containerRect.top + document.documentElement.scrollTop - headerHeight - 30;

      // Procesar lazy loading de forma segura
      const lazyImages = container.querySelectorAll('.lazyload');
      if (window.lazySizes && lazyImages.length > 0) {
        lazyImages.forEach((image) => {
          try {
            lazySizes.loader.unveil(image);
          } catch (e) {
            console.warn('Error unveiling lazy image:', e);
          }
        });
      }

      // Scroll suave con validación
      if (top >= 0) {
        window.scrollTo({
          top: top,
          left: 0,
          behavior: "smooth"
        });
      }
    } catch (error) {
      console.error('Error in renderProductGridContainer:', error);
    }
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    // SOLUCIÓN DE EMERGENCIA: No reinstanciar clases
    // new FacetsToggle();
    // new SidebarToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      document.querySelector(selector).classList.remove('loading');
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const currentUrl = new URL(window.location.href);
    const newParams = new URLSearchParams(searchParams);
    
    // Preservar los parámetros de localización si existen
    const localizationParams = ['country_code'];
    localizationParams.forEach(param => {
      const value = currentUrl.searchParams.get(param);
      if (value) {
        newParams.set(param, value);
      }
    });
    
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? '?' + newParams.toString() : ''}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid || !productGrid.dataset || !productGrid.dataset.id) {
      console.warn('Product grid element not found or missing dataset.id');
      return [];
    }
    
    return [
      {
        section: productGrid.dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    // SOLUCIÓN DE EMERGENCIA: Método simplificado y robusto
    if (this.isProcessing) {
      return;
    }
    
    this.isProcessing = true;
    
    try {
      const form = event.target.closest('form');
      if (!form) {
        this.isProcessing = false;
        return;
      }
      
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);
      const newParamsString = searchParams.toString();
      
      // Solo procesar si realmente cambió algo
      if (newParamsString !== FacetFiltersForm.searchParamsPrev) {
        // Usar timeout para evitar bloqueos
        setTimeout(() => {
          try {
            FacetFiltersForm.renderPage(newParamsString, event);
          } catch (error) {
            console.error('Error in renderPage:', error);
          } finally {
            this.isProcessing = false;
          }
        }, 100);
      } else {
        this.isProcessing = false;
      }
      
    } catch (error) {
      console.error('Error in onSubmitHandler:', error);
      this.isProcessing = false;
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  onMore(e) {
    let ul = this.closest('.thb-filter-content').querySelector('ul');

    if (ul.hasAttribute('filters-open')) {
      this.textContent = theme.strings.showMore;
      ul.removeAttribute('filters-open');
    } else {
      this.textContent = theme.strings.showLess;
      ul.setAttribute('filters-open', '');
    }
    e.preventDefault();
  }

  onSortChange(event) {
    event.preventDefault();
    if (this.isProcessing) return;

    // Mostrar el spinner
    const spinner = document.querySelector('.loading-overlay__spinner');
    if (spinner) {
      spinner.classList.remove('hidden');
    }

    // Deshabilitar el select mientras carga
    const select = event.target;
    if (select) {
      select.disabled = true;
    }

    this.isProcessing = true;

    // Construir los parámetros de búsqueda
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('sort_by', select.value);

    // Obtener la sección actual
    const section = FacetFiltersForm.getSections()[0];
    if (!section) {
      console.error('No se encontró la sección');
      return;
    }

    // Construir la URL para la petición AJAX
    const url = `${window.location.pathname}?section_id=${section.section}&${searchParams.toString()}`;

    // Realizar la petición AJAX
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(html => {
        // Actualizar la grilla de productos
        const parser = new DOMParser();
        const parsedDoc = parser.parseFromString(html, 'text/html');
        
        // Actualizar el contenedor de productos
        const container = document.getElementById('ProductGridContainer');
        const newContainer = parsedDoc.getElementById('ProductGridContainer');
        if (container && newContainer) {
          container.innerHTML = newContainer.innerHTML;
        }

        // Actualizar la URL sin recargar
        window.history.pushState(
          { searchParams: searchParams.toString() },
          '',
          `${window.location.pathname}?${searchParams.toString()}`
        );
      })
      .catch(error => {
        console.error('Error:', error);
        // Si hay un error, recargar la página
        window.location.href = `${window.location.pathname}?${searchParams.toString()}`;
      })
      .finally(() => {
        // Ocultar el spinner
        if (spinner) {
          spinner.classList.add('hidden');
        }
        
        // Rehabilitar el select
        if (select) {
          select.disabled = false;
        }
        
        this.isProcessing = false;
      });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.currentFetch = null;

customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 *  @class
 *  @function FacetRemove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);


/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productGrid = this.closest('#ProductGridContainer');
    this.compareToggle = this.querySelector('#compare_toggle');
    this.layoutSwitcher = this.querySelector('.facets--bar-view-as');
    this.buttons = this.querySelectorAll('.facets--bar-view-as-button');
    this.productLayout = window.localStorage.getItem('product-layout');
    if (this.layoutSwitcher) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          [].forEach.call(this.buttons, function (el) {
            el.removeAttribute('disabled');
          });
          this.onLayoutChange(button, button.dataset.value);
          evt.preventDefault();
        });
      });

      if (this.productLayout && this.productLayout === 'list') {
        const toggle = this.querySelector(`.facets--bar-view-as-button-${this.productLayout}`);
        if (toggle) toggle.click();
      }
    }
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onLayoutChange(button, value) {
    button.setAttribute('disabled', '');
    this.productGrid.dataset.layout = value;
    window.localStorage.setItem('product-layout', value);
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }

  // Función para detectar si la moneda usa coma decimal
  isCommaDecimalCurrency() {
    const currenciesUsingCommaDecimals = ['ANG', 'ARS', 'BRL', 'BYN', 'BYR', 'CLF', 'CLP', 'COP', 'CRC', 'CZK', 'DKK', 'EUR', 'HRK', 'HUF', 'IDR', 'ISK', 'MZN', 'NOK', 'PLN', 'RON', 'RUB', 'SEK', 'TRY', 'UYU', 'VES', 'VND'];
    // Obtener la moneda actual del atributo data-currency del elemento price-slider
    const currentCurrency = this.dataset.currency || 'ARS'; // Default a ARS si no se encuentra
    return currenciesUsingCommaDecimals.includes(currentCurrency);
  }

  // Función para convertir valor de coma decimal a punto decimal para JavaScript
  convertCommaToDot(value) {
    if (typeof value === 'string') {
      // Si el valor tiene coma decimal, convertir a punto decimal
      return value.replace(',', '.');
    }
    return value;
  }

  // Función para convertir valor de punto decimal a coma decimal para display
  convertDotToComma(value) {
    if (typeof value === 'string' || typeof value === 'number') {
      const strValue = value.toString();
      // Si el valor tiene punto decimal, convertir a coma decimal
      return strValue.replace('.', ',');
    }
    return value;
  }

  connectedCallback() {
    this.slider = this.querySelector('.price_slider');
    this.amounts = this.querySelector('.price_slider_amount');
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.inputEvent = new CustomEvent('input');
    this.usesCommaDecimal = this.isCommaDecimalCurrency();

    // Convertir los valores de los data attributes para JavaScript
    const minValue = this.convertCommaToDot(this.slider.dataset.minValue || 0);
    const maxValue = this.convertCommaToDot(this.slider.dataset.maxValue || this.slider.dataset.max);
    const rangeMax = this.convertCommaToDot(this.slider.dataset.max);

    const args = {
      start: [
        parseFloat(minValue),
        parseFloat(maxValue)
      ],
      connect: true,
      step: 10,
      direction: document.dir,
      handleAttributes: [
        { 'aria-label': 'lower' },
        { 'aria-label': 'upper' },
      ],
      range: {
        'min': 0,
        'max': parseFloat(rangeMax)
      }
    };
    noUiSlider.create(this.slider, args);

    this.slider.noUiSlider.on('update', this.onSliderUpdate.bind(this));
    this.slider.noUiSlider.on('change', this.onSliderChange.bind(this));

    // Inicializar los inputs con el formato correcto
    this.initializeInputs();
  }

  // Función para inicializar los inputs con el formato correcto
  initializeInputs() {
    const minInput = this.amounts.querySelector('.field__input_min');
    const maxInput = this.amounts.querySelector('.field__input_max');
    
    if (minInput && maxInput) {
      // Obtener los valores actuales de los inputs
      let minValue = minInput.value;
      let maxValue = maxInput.value;
      
      if (this.usesCommaDecimal) {
        // Para monedas que usan coma decimal (como ARS)
        
        // Convertir valores si vienen con formato incorrecto
        if (minValue.includes('.')) {
          minValue = minValue.replace('.', ',');
        }
        if (maxValue.includes('.')) {
          maxValue = maxValue.replace('.', ',');
        }
        
        // Formatear con puntos de miles
        const formatWithThousands = (value) => {
          const parts = value.split(',');
          if (parts[0]) {
            // Agregar puntos de miles a la parte entera
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }
          return parts.join(',');
        };
        
        minInput.value = formatWithThousands(minValue);
        maxInput.value = formatWithThousands(maxValue);
      } else {
        // Si los valores vienen con coma decimal, convertirlos a punto decimal
        if (minValue.includes(',')) {
          minValue = minValue.replace(',', '.');
          minInput.value = minValue;
        }
        if (maxValue.includes(',')) {
          maxValue = maxValue.replace(',', '.');
          maxInput.value = maxValue;
        }
      }

      // Agregar event listeners para formateo automático
      minInput.addEventListener('input', this.formatInputValue.bind(this));
      maxInput.addEventListener('input', this.formatInputValue.bind(this));
    }
  }

  // Función para formatear el valor del input mientras el usuario escribe
  formatInputValue(event) {
    const input = event.target;
    let value = input.value;
    
    // Remover caracteres no numéricos excepto punto, coma y espacios
    value = value.replace(/[^\d.,\s]/g, '');
    
    if (this.usesCommaDecimal) {
      // Para monedas que usan coma decimal (como ARS)
      
      // Remover puntos de miles existentes para procesar
      value = value.replace(/\./g, '');
      
      // Asegurar que solo haya una coma decimal
      const commaCount = (value.match(/,/g) || []).length;
      if (commaCount > 1) {
        value = value.replace(/,/g, (match, index) => {
          return index === value.lastIndexOf(',') ? match : '';
        });
      }
      
      // Convertir punto a coma si es necesario
      if (value.includes('.')) {
        value = value.replace('.', ',');
      }
      
      // Formatear con puntos de miles
      const parts = value.split(',');
      if (parts[0]) {
        // Agregar puntos de miles a la parte entera
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      
      value = parts.join(',');
    } else {
      // Para monedas que usan punto decimal, asegurar que solo haya un punto
      const dotCount = (value.match(/\./g) || []).length;
      if (dotCount > 1) {
        value = value.replace(/\./g, (match, index) => {
          return index === value.lastIndexOf('.') ? match : '';
        });
      }
      // Convertir coma a punto si es necesario
      if (value.includes(',')) {
        value = value.replace(',', '.');
      }
    }
    
    input.value = value;
  }

  onSliderUpdate(values) {
    const minInput = this.amounts.querySelector('.field__input_min');
    const maxInput = this.amounts.querySelector('.field__input_max');
    
    if (this.usesCommaDecimal) {
      // Para monedas que usan coma decimal (como ARS), formatear con puntos de miles y coma decimal
      const formatArgentineCurrency = (value) => {
        // Convertir a número y formatear con puntos de miles
        const numValue = parseFloat(value);
        if (isNaN(numValue)) return value;
        
        // Formatear con puntos de miles y coma decimal
        return numValue.toLocaleString('es-AR', {
          minimumFractionDigits: 4,
          maximumFractionDigits: 2
        });
      };
      
      minInput.value = formatArgentineCurrency(values[0]);
      maxInput.value = formatArgentineCurrency(values[1]);
    } else {
      // Para monedas que usan punto decimal, mostrar con punto
      minInput.value = values[0];
      maxInput.value = values[1];
    }
  }

  onSliderChange(values) {
    // Solo disparar evento si los valores realmente cambiaron
    const currentMin = parseFloat(this.amounts.querySelector('.field__input_min').value.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
    const currentMax = parseFloat(this.amounts.querySelector('.field__input_max').value.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
    
    if (Math.abs(currentMin - parseFloat(values[0])) > 0.01 || 
        Math.abs(currentMax - parseFloat(values[1])) > 0.01) {
      this.form.querySelector('form').dispatchEvent(this.inputEvent);
    }
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
  new SidebarToggle();
});